import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';

import { apiV1 } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

export type UpdateEventDTO = {
  id: string;
  companyId: string;
  title: string;
  start_date: string;
  end_date?: string;
  description: string;
  local?: string;
  before_market?: 'time' | 'before_market' | 'after_market' | 'full_day';
  impact_id: number;
  event_type_id: number;
  shareholders: string[];
  contact_ids: string[];
  is_created_by_admin?: boolean;
};

export const updateEvent = async (data: UpdateEventDTO): Promise<unknown> => {
  return apiV1.put(`/v1/irm/event/${data.id}`, {
    title: data.title,
    description: data.description,
    local: data.local,
    before_market: data.before_market,
    impact_id: data.impact_id,
    start_date: data.start_date,
    end_date: data.end_date,
    event_type_id: data.event_type_id,
    shareholders: data.shareholders,
    contact_ids: data.contact_ids,
    company_id: data.companyId,
    is_created_by_admin: data.is_created_by_admin,
  });
};

type UseUpdateEventOptions = {
  config?: MutationConfig<typeof updateEvent>;
};

export const useUpdateEvent = ({ config }: UseUpdateEventOptions) => {
  return useMutation({
    onError: () => {
      notification.error({
        message: `Não foi possível atualizar oevento.`,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['events', variables.companyId]);
      notification.success({
        message: `Evento atualizado com sucesso.`,
      });
    },
    ...config,
    mutationFn: updateEvent,
  });
};
